import { APP_CONFIG } from '@/utils/constants'

const appUrl = APP_CONFIG.urlQuestionImg
export const APP_URL_REPLACE = 'APP_URL_REPLACE'
export const LINK_CMS = APP_CONFIG.cmsLinkImg

export const setContentMediaEditorShow = (question, type = '') => {
  let result = JSON.stringify(question)
  result = JSON.parse(result)
  if (result.content) {
    result.content = result.content.replaceAll(APP_URL_REPLACE, appUrl)
    result.content = result.content.replaceAll(LINK_CMS, `${appUrl}/`)
  }
  if (type === 'group' && result.listQuestionChild) {
    result.listQuestionChild.map(ques => {
      ques.content = ques.content.replaceAll(APP_URL_REPLACE, appUrl)
      ques.content = ques.content.replaceAll(LINK_CMS, `${appUrl}/`)
      ques.answers && ques.answers.map(ans => {
        if (ans.content) {
          ans.content = ans.content.replaceAll(APP_URL_REPLACE, appUrl)
          ans.content = ans.content.replaceAll(LINK_CMS, `${appUrl}/`)
        }
      })
    })
  } else {
    result.answers && result.answers.map(ans => {
      if (ans.content) {
        ans.content = ans.content.replaceAll(APP_URL_REPLACE, appUrl)
        ans.content = ans.content.replaceAll(LINK_CMS, `${appUrl}/`)
      }
    })
  }
  return result
}
